export default {
    checkInOutLater: 'Check In / Out Later',
    date: 'Date',
    forgetDate: 'Forget Date',
    request: 'Request',
    selectType: '- Select type -',
    checkInTime: 'Check In Time',
    checkOutTime: 'Check Out Time',
    selectTime: '- Select Time -',
    cancel: 'Cancel',
    submit: 'Submit',
    invalidTime: 'Invalid time',
    fieldRequired: 'This field is required',
    fieldLessThanCharacters: 'This field should be less than 255 characters',
    msgSuccessSingleDay: 'Your application success at $startDate',
    msgSuccessRange: 'Your application success at $startDate to $endDate',
    cannotGetLineId: 'Cannot get line user id',
    reason: 'Reason',
    reasonMsg: 'Detail of your request',
    approve: 'Approve',
    reject: 'Reject',
    back: 'back',
    count: 'Number of time',
    time: 'Time'
}
